export default {
  ziweiMaj: 'emperor',
  tianjiMaj: 'advisor',
  taiyangMaj: 'sun',
  wuquMaj: 'general',
  tiantongMaj: 'fortunate',
  lianzhenMaj: 'judge',
  tianfuMaj: 'empress',
  taiyinMaj: 'moon',
  tanlangMaj: 'wolf',
  jumenMaj: 'advocator',
  tianxiangMaj: 'minister',
  tianliangMaj: 'sage',
  qishaMaj: 'marshal',
  pojunMaj: 'rebel',
  zuofuMin: 'officer',
  youbiMin: 'helper',
  wenchangMin: 'scholar',
  wenquMin: 'artist',
  lucunMin: 'money',
  tianmaMin: 'horse',
  qingyangMin: 'goat',
  tuoluoMin: 'dala',
  huoxingMin: 'mars',
  lingxingMin: 'spark',
  tiankuiMin: 'assistant',
  tianyueMin: 'aide',
  dikongMin: 'ideologue',
  dijieMin: 'scatterbrain',
  tiankong: 'utopian',
  tianxing: 'serious',
  tianyao: 'social',
  jieshen: 'considery',
  yinsha: 'gloomy',
  tianxi: 'cheerful',
  tianguan: 'solemn',
  tianfu: 'lucky',
  tianku: 'upset',
  tianxu: 'frail',
  longchi: 'talented',
  fengge: 'refined',
  hongluan: 'attractive',
  guchen: 'alone',
  guasu: 'lonely',
  feilian: 'instigated',
  posui: 'broken',
  taifu: 'honorable',
  fenggao: 'awarded',
  tianwu: 'psychic',
  tianyue: 'sickly',
  santai: 'senior',
  bazuo: 'dignified',
  engguang: 'grateful',
  tiangui: 'noble',
  tiancai: 'gifted',
  tianshou: 'ageless',
  jiekong: 'interrupted',
  xunzhong: 'meditative',
  xunkong: 'fancied',
  kongwang: 'bottomless',
  jielu: 'intercepted',
  yuede: 'peaceful',
  tianshang: 'wounded',
  tianshi: 'heaven',
  tianchu: 'gourmet',
  changsheng: 'born',
  muyu: 'infancy',
  guandai: 'adolescence',
  linguan: 'adulthood',
  diwang: 'prime',
  shuai: 'weak',
  bing: 'sick',
  si: 'dead',
  mu: 'buried',
  jue: 'dissipated',
  tai: 'embryo',
  yang: 'molding',
  boshi: 'doctor',
  lishi: 'sumo',
  qinglong: 'dragon',
  xiaohao: 'consumer',
  jiangjun: 'general',
  zhoushu: 'book',
  faylian: 'gossip',
  xishen: 'happiness',
  bingfu: 'illness',
  dahao: 'wastrel',
  fubing: 'ambush',
  guanfu: 'government',
  suijian: 'initial',
  huiqi: 'unlucky',
  sangmen: 'downcast',
  guansuo: 'tied',
  gwanfu: 'official',
  longde: 'virtuous',
  baihu: 'sinister',
  tiande: 'blessed',
  diaoke: 'sorrowing',
  jiangxing: 'capable',
  panan: 'admired',
  suiyi: 'varied',
  xiishen: 'listless',
  huagai: 'religious',
  jiesha: 'robbed',
  zhaisha: 'disastery',
  tiansha: 'condemned',
  zhibei: 'insidious',
  xianchi: 'passionate',
  yuesha: 'hapless',
  wangshen: 'perished',
  yunkui: 'assistant(decadal)',
  yunyue: 'aide(decadal)',
  yunchang: 'scholar(decadal)',
  yunqu: 'artist(decadal)',
  yunluan: 'attractive(decadal)',
  yunxi: 'cheerful(decadal)',
  yunlu: 'money(decadal)',
  yunyang: 'goat(decadal)',
  yuntuo: 'dala(decadal)',
  yunma: 'horse(decadal)',
  liukui: 'assistant(yearly)',
  liuyue: 'aide(yearly)',
  liuchang: 'scholar(yearly)',
  liuqu: 'artist(yearly)',
  liuluan: 'attractive(yearly)',
  liuxi: 'cheerful(yearly)',
  liulu: 'money(yearly)',
  liuyang: 'goat(yearly)',
  liutuo: 'dala(yearly)',
  liuma: 'horse(yearly)',
  nianjie: 'considery(yearly)',
} as const;
